type DayNoteType = "Day";
export type NoteTypesType = DayNoteType;

const NoteTypes = {
    Day: "Day" as DayNoteType
};

export default NoteTypes;